import type * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateClassroomSubjectAccessMutationVariables = Types.Exact<{
  classroomId: Types.Scalars['ID']['input'];
  subjectId: Types.Scalars['ID']['input'];
  input: Types.UpdateClassroomSubjectAccessInput;
}>;


export type UpdateClassroomSubjectAccessMutation = { __typename?: 'RootMutationType', updateClassroomSubjectAccess: { __typename?: 'UpdateClassroomSubjectAccessResult', result?: { __typename?: 'ClassroomSubject', id: string, classroomId: string, subjectId: string, restrictFreePractice?: boolean | null, partialCreditEnabled?: boolean | null } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null, code?: string | null }> } };


export const UpdateClassroomSubjectAccessDocument = gql`
    mutation UpdateClassroomSubjectAccess($classroomId: ID!, $subjectId: ID!, $input: UpdateClassroomSubjectAccessInput!) {
  updateClassroomSubjectAccess(
    classroomId: $classroomId
    subjectId: $subjectId
    input: $input
  ) {
    result {
      id
      classroomId
      subjectId
      restrictFreePractice
      partialCreditEnabled
    }
    errors {
      message
      code
    }
  }
}
    `;
export type UpdateClassroomSubjectAccessMutationFn = Apollo.MutationFunction<UpdateClassroomSubjectAccessMutation, UpdateClassroomSubjectAccessMutationVariables>;

/**
 * __useUpdateClassroomSubjectAccessMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomSubjectAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomSubjectAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassroomSubjectAccessMutation, { data, loading, error }] = useUpdateClassroomSubjectAccessMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      subjectId: // value for 'subjectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassroomSubjectAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassroomSubjectAccessMutation, UpdateClassroomSubjectAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassroomSubjectAccessMutation, UpdateClassroomSubjectAccessMutationVariables>(UpdateClassroomSubjectAccessDocument, options);
      }
export type UpdateClassroomSubjectAccessMutationHookResult = ReturnType<typeof useUpdateClassroomSubjectAccessMutation>;
export type UpdateClassroomSubjectAccessMutationResult = Apollo.MutationResult<UpdateClassroomSubjectAccessMutation>;
export type UpdateClassroomSubjectAccessMutationOptions = Apollo.BaseMutationOptions<UpdateClassroomSubjectAccessMutation, UpdateClassroomSubjectAccessMutationVariables>;